var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history_box"},[_c('div',{staticStyle:{"font-size":"0.16rem","color":"#666"}},[_vm._v(" "+_vm._s(_vm.$store.state.history.father_name)+" / "+_vm._s(_vm.$store.state.history.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }